/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { systemIdentifierIdGet } from '../fn/system-identifier/system-identifier-id-get';
import { SystemIdentifierIdGet$Params } from '../fn/system-identifier/system-identifier-id-get';
import { systemIdentifierPost } from '../fn/system-identifier/system-identifier-post';
import { SystemIdentifierPost$Params } from '../fn/system-identifier/system-identifier-post';
import { SystemIdentifierRecordModel } from '../models/system-identifier-record-model';
import { SystemIdentifierRecordModelSearchResultModel } from '../models/system-identifier-record-model-search-result-model';
import { systemIdentifierSearchSystemIdentifierPost } from '../fn/system-identifier/system-identifier-search-system-identifier-post';
import { SystemIdentifierSearchSystemIdentifierPost$Params } from '../fn/system-identifier/system-identifier-search-system-identifier-post';

@Injectable({ providedIn: 'root' })
export class MDISystemIdentifierService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `systemIdentifierSearchSystemIdentifierPost()` */
  static readonly SystemIdentifierSearchSystemIdentifierPostPath = '/SystemIdentifier/SearchSystemIdentifier';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `systemIdentifierSearchSystemIdentifierPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  systemIdentifierSearchSystemIdentifierPost$Response(params?: SystemIdentifierSearchSystemIdentifierPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<SystemIdentifierRecordModelSearchResultModel>> {
    return systemIdentifierSearchSystemIdentifierPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `systemIdentifierSearchSystemIdentifierPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  systemIdentifierSearchSystemIdentifierPost(params?: SystemIdentifierSearchSystemIdentifierPost$Params, context?: HttpContext): Observable<SystemIdentifierRecordModelSearchResultModel> {
    return this.systemIdentifierSearchSystemIdentifierPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<SystemIdentifierRecordModelSearchResultModel>): SystemIdentifierRecordModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `systemIdentifierIdGet()` */
  static readonly SystemIdentifierIdGetPath = '/SystemIdentifier/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `systemIdentifierIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  systemIdentifierIdGet$Response(params: SystemIdentifierIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<SystemIdentifierRecordModel>> {
    return systemIdentifierIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `systemIdentifierIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  systemIdentifierIdGet(params: SystemIdentifierIdGet$Params, context?: HttpContext): Observable<SystemIdentifierRecordModel> {
    return this.systemIdentifierIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<SystemIdentifierRecordModel>): SystemIdentifierRecordModel => r.body)
    );
  }

  /** Path part for operation `systemIdentifierPost()` */
  static readonly SystemIdentifierPostPath = '/SystemIdentifier';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `systemIdentifierPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  systemIdentifierPost$Response(params?: SystemIdentifierPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return systemIdentifierPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `systemIdentifierPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  systemIdentifierPost(params?: SystemIdentifierPost$Params, context?: HttpContext): Observable<string> {
    return this.systemIdentifierPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
